import { useTheme } from '@/hooks/theme.hooks';

export function FormLogo(): JSX.Element {
  const { theme } = useTheme();
  const Logo = theme?.logo;

  return <div className="form-logo">{Logo && <Logo />}</div>;
}
